module.exports = __webpack_public_path__ + "static/media/egg.c7e76450.png";